import PropTypes from 'prop-types'
import React, { useEffect } from "react"
import { connect } from "react-redux"


import { logoutUser } from "../../store/actions"

import {
  useLocation,
  useNavigate,
  useParams
} from "react-router-dom";

function withRouter(Component) {
  function ComponentWithRouterProp(props) {
    let location = useLocation();
    let navigate = useNavigate();
    let params = useParams();
    return (
      <Component
        {...props}
        router={{ location, navigate, params }}
      />
    );
  }

  return ComponentWithRouterProp;
}

const Logout = props => {
  useEffect(() => {
    props?.logoutUser({ push: props?.router?.navigate })
  })

  return <></>
}

Logout.propTypes = {
  history: PropTypes.object,
  logoutUser: PropTypes.func
}

export default withRouter(connect(null, { logoutUser })(Logout))
